(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rosy-purchase-planner"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rosy-product-date]').forEach((root) => {
    const input = root.querySelector('[data-event-date-input]');
    const checkButton = root.querySelector('[data-check-date]');
    const clearButton = root.querySelector('[data-clear-date]');
    const result = root.querySelector('[data-date-result]');
    const storageKey = 'rosy_v5_event_date';
    const has15DayDelivery = root.dataset.has15DayDelivery === 'true';

    const parseDate = (value) => {
      const match = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (!match) return null;
      const month = Number(match[1]);
      const day = Number(match[2]);
      const year = Number(match[3]);
      const date = new Date(year, month - 1, day, 12);
      if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
      return date;
    };

    const saveCartAttribute = async (value) => {
      try {
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Event Date': value } })
        });
      } catch (error) {
        return;
      }
    };

    const assess = () => {
      const eventDate = parseDate(input.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      result.hidden = false;
      if (!eventDate) {
        result.textContent = 'Enter a valid date in MM/DD/YYYY format.';
        return;
      }
      if (eventDate < today) {
        result.textContent = 'Please choose a future event date.';
        return;
      }

      const days = Math.ceil((eventDate.getTime() - today.getTime()) / 86400000);
      let message = 'Your date allows more planning time. Continue with your order and review the product-specific shipping details.';
      if (has15DayDelivery && days >= 15) {
        message = 'Your event date allows the 15-day standard delivery time. You can continue with your order.';
      } else if (has15DayDelivery) {
        message = 'Standard delivery for this product is 15 days. Rush delivery may be available; contact us for a timing review.';
      } else if (days < 30) {
        message = 'Rush delivery options may be available. You can continue ordering, or contact us for a timing review.';
      } else if (days < 50) {
        message = 'Your event is approaching. You can continue ordering, or contact us if you would like a timing review.';
      }

      result.textContent = message;
      clearButton.hidden = false;
      localStorage.setItem(storageKey, input.value);
      saveCartAttribute(input.value);
    };

    const savedDate = localStorage.getItem(storageKey);
    if (savedDate) {
      input.value = savedDate;
      assess();
    }

    checkButton.addEventListener('click', assess);
    clearButton.addEventListener('click', () => {
      input.value = '';
      result.hidden = true;
      clearButton.hidden = true;
      localStorage.removeItem(storageKey);
      saveCartAttribute('');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
